import React from 'react';
import Header from '../Components/GlobalComponent/Header';
import Footer from '../Components/GlobalComponent/Footer';
import Banner from '../Components/VacanciesComponent/Banner';
import Vacancies from '../Components/VacanciesComponent/Vacancies';

const VacanciesPage = () => {
    return (
        <div>
            <Header/>
            <Banner/>
            <Vacancies/>
            <Footer/>
        </div>
    );
};

export default VacanciesPage;
